
<template>
<div  class="page-container mt-10" >
  
  <div class="loading-container" style="padding-left:60px;padding-right:60px;padding-top:20px;">
   

      <h1>
      アカウントを
    <ruby><rb>登録</rb><rt>とうろく</rt></ruby>!
    <!-- <ruby><rb>始</rb><rt>はじ</rt></ruby>よう！ -->

    </h1>



<!-- ローディング -->
<t-loading class="loading-item" :isLoading="IsLoading"></t-loading>
<!-- メールアドレス -->
  <t-input v-model="ruleForm.email"
                name="email"
                v-validate="'required|email|max:254'"
                :readonly=false
                :enterToEditEnd =false
                v-bind:class="{disable:IsLoading}"
                placeholder="メールアドレスをいれてね"
                label="メールアドレス"
                iconClassName="far fa-envelope"
                :isShowErrorMessage="errors.has('email')"
                :errorMessage="errors.first('email')"
                :showRequireTag=true
                radius="20px"
                ></t-input> 
<!-- ・パスワード -->
  <t-input v-model="ruleForm.password"
                v-validate="{required:true,min:6,max:20}"
                name="password"
                v-bind:class="{disable:IsLoading}"
                :enterToEditEnd =false
                inputType="password"
                :maxlength=20
                placeholder="パスワード"
                style="margin-top:10px;"
                label="パスワード"
                iconClassName="fas fa-key"
                :showRequireTag=true
                :isShowErrorMessage="errors.has('password')"
                :errorMessage="errors.first('password')"
                radius="20px"
                ></t-input> 
  <!-- パスワード確認 -->
  <t-input v-model="ruleForm.checkPass"
                v-validate="{required:true,is:ruleForm.password}" 
                name="checkPass"
                v-bind:class="{disable:IsLoading}"
                :enterToEditEnd =false
                inputType="password"
                :maxlength=20
                placeholder="パスワードをもういちど"
                label="パスワードかくにん"
                :showRequireTag=true
                :isShowErrorMessage="errors.has('checkPass')"
                :errorMessage="errors.first('checkPass')"
                iconClassName="fas fa-key"
                radius="20px"
                ></t-input> 


 <!-- ログインボタン -->
 <div @click="SubmitForm()" v-bind:class="{disable:IsLoading || errors.has('email')|| errors.has('password') || errors.has('checkPass')}" class="button-edit mt-10">
      <i class="far fa-circle"></i>
      <ruby><rb>登録</rb><rt>とうろく</rt></ruby>する
      <div class="eigi">Regist</div>
  </div>


  
   
  </div>

  
  </div>
  
</template>

<script>

//検証メッセージのカスタマイズ処理
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    email: {
      required: 'メールアドレスをいれてね！',
      email: 'ただしいメールアドレスをいれてね！',
      max: '※ 254文字以内でメールアドレスをいれてね',
    },
  
    password:{
      required: 'パスワードをいれてね',
      min: 'パスワードは6文字から20文字以内でいれてね',
      max: 'パスワードは6文字から20文字以内でいれてね'
    },
    checkPass:{
      is: '同じパスワードをいれてね',
    },
  }
}
Validator.localize('ja', dict)



import TInput from "../TInput";
import Tloading from "../TLoading";
export default {
  name: "AnonymousRegistAccount",
  components: {
    TInput,
     "t-loading":Tloading,
  },
  data() {
    return {
      ruleForm: {
        email: "",
        password: "",
        checkPass: ""
      },
      IsLoading:false,//登録処理ローディング
    
    };
  },
  mounted(){
    this.$refs.email.ToFocus();

  },
  computed: {

  },
  methods: {

    //================================
    //処理：登録するボタンクリック時
    //================================
    SubmitForm() {
      //値の検証
      this.$validator.validateAll().then((result) => {
        　//NG
          if (false === result) {
            return;
          }

          //OK
          this.AnonymousToRegAccount();
      });
    },

    AnonymousToRegAccount()
    {  
      this.IsLoading = true;

       var callback = function(result,msg) {
        if(result === false)
        {
          alert(msg);
        }
        this.IsLoading = false
        location.reload();

      }.bind(this);

      this.$store.dispatch("AnonymousToRegAccount", {
            email: this.ruleForm.email,
            password:this.ruleForm.password,
            callback:callback
          });


    },

    resetForm() {
        this.$validator.reset()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.page-container{
  display: flex;

  justify-content: center;
  align-items:center;
}

.page-content{
  //background:white;
  border-radius: 10px;
  padding:40px;

}


.back{
  display: block;
  margin-top:24px;
  text-align: left;
  display: inline-block;
  font-size: 16px;
  text-decoration: none;
  & > i {
    margin-right: 8px;
  }
  &:hover {
    color: coral;
  }

  color: #42b983;
  cursor: pointer;

}

//---------------
// :ローディングのスタイル
//---------------
.loading-container
{
  position: relative;
  .loading-item {
    position: absolute;
    bottom: 50%;
    left: 80px;
    z-index: 999;
    transform: scale(1);
  }
}

//---------------
// :無効時のスタイル
//---------------
.disable {
  opacity: 0.3;
  cursor: default;
  pointer-events: none; // クリック、タッチを無効化
  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

//--------------
 //ボタン:編集
 //--------------
.button-edit{
  cursor: pointer;
  color:#fff;
  display: inline-block;
  //border:1px solid #42b983;
  background:#42b983;
  text-align: center;
  border-radius: 25px;
  padding-top:10px;
  padding-bottom:0px;
  padding-left:20px;
  padding-right:18px;
  vertical-align: middle;
  letter-spacing: 32x;
  font-weight: 600;
  font-size:16px;
  width:300px;
  transition: all 200ms 0s ease;
  box-shadow: 0px 3px #228659;

  & > .eigi{
    font-size:14px;
    font-weight: normal;
    margin-bottom:4px;
  }


  &:hover{
    background:#228659;

  }

  & > i{
    margin-right:5px;
    font-size:16px;
    font-weight: normal;
  }
}


h2 {
  font-weight: normal;
}
h1{
  /* //縁取り文字 */
    font-weight: 600;
    color:yellow;
    margin-block-start: 0;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: #666;

    & > ruby > rt{
      color:#666;
      font-size:12px;
      -webkit-text-stroke-width: 0px;
    }
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/AnonymousRegistAccount.vue